import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Withdrawal_Payment_Reports from "./Components/Withdrawal/Withdrawal_Payment_Reports";
import Withdrawal_Pending_List from "./Components/Withdrawal/Withdrawal_Pending_List";
import Login from "./Components/Login/Login";
import OPT_Confirm from "./Components/Login/OPT_Confirm";
import Message from "./Components/Dashboard Message/Message";
import MessageHistory from "./Components/Dashboard Message/MessageHistory";
import ProtectedRoute from "./Redux/actions/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Buy from "./Components/Trading/Buy";
import Sell from "./Components/Trading/Sell";
import Edit_details from "./Components/Member/Edit_details";
import HelpDesk from "./Components/HelpDesk/HelpDesk";
import News from "./Components/HelpDesk/News";
import Reply from "./Components/HelpDesk/Reply";
import Commission from "./Components/HelpDesk/Commission";
import LoginHistory from "./Components/HelpDesk/LoginHistory";
// import ApprovedKyc  from "./Components/Kyc/ApprovedKyc";
// import PendingKyc from "./Components/Kyc/PendingKyc";
import Manage_subadmin from "./Components/Sub_Admin/Manage_subadmin";
import Subadmin_rights from "./Components/Sub_Admin/Subadmin_rights";
import Edit_subAdmin from "./Components/Sub_Admin/Edit_subAdmin";
import Add_subAdmin from "./Components/Sub_Admin/Add_subAdmin";
import My_Team from "./Components/Team_Reports/My team";
import Contact from "./Components/Contact/Contact";
import Add_HomePageCoin from "./Components/HomePageCoin/Add_HomePageCoin";
import HomePageCoinDetails from "./Components/HomePageCoin/HomePageCoinDetails";
import Update_HomePageCoin from "./Components/HomePageCoin/Update_HomePageCoin";
import RequestToken from "./Components/Request Token/RequestToken";
import RequestTokenUpdate from "./Components/Request Token/RequestTokenUpdate";
import RequestTokenPaid from "./Components/Request Token/RequestTokenPaid";
import RequestTokenCancel from "./Components/Request Token/RequestTokenCancel";
import Active_Member from "./Components/Member/ACTIVE_MEMBER_LIST";
import Level_detail from "./Components/Team_Reports/Level_detail";
import Direct_team from "./Components/Team_Reports/Direct_team";
import ActivationByAdmin from "./Components/Activation/ActivationByAdmin";
import All_member from "./Components/Member/All_member";
import UpgradeID from "./Components/Activation/UpgradeID";
import ActivationUHistory from "./Components/Activation/ActivationUHistory";
import DirectLegBusiness from "./Components/Team_Reports/DirectLegBusiness";
import AddPowerleg from "./Components/Power Leg/AddPowerleg";
import PowerlegHis from "./Components/Power Leg/PowerlegHis";
import RoiRate from "./Components/Power Leg/RoiRate";
import LevelIncome from "./Components/Income Reports/LevelIncome";
import TeamReward_income from "./Components/Income Reports/TeamReward_income";
import Total_incomeReport from "./Components/Income Reports/Total_incomeReport";
import RoiIncome from "./Components/Income Reports/RoiIncome";
import ClosedHelpDesk from "./Components/HelpDesk/ClosedHelpDesk";
import SubadminHistory from "./Components/Sub_Admin/SubadminHistory";
import Member_Details from "./Components/Member/Member_Details";
import DirectIncome from "./Components/Income Reports/DirectIncome";
import Upgrade_MEMBER_LIST from "./Components/Member/Upgrade_MEMBER_LIST";
import TeamRewardPaid from "./Components/Income Reports/TeamRewardPaid";
import Withdrawal_Pending_List_nonworking from "./Components/Withdrawal/PendingClaimActvationHistory";
import Withdrawal_Payment_Reports_nonworking from "./Components/Withdrawal/PaidClaimActvationHistory";
import PendingClaimActvationHistory from "./Components/Withdrawal/PendingClaimActvationHistory";
import PaidClaimActvationHistory from "./Components/Withdrawal/PaidClaimActvationHistory";
import UpgradeByAdmin from "./Components/Activation/UpgradeByAdmin";
import ActivationUserHistory from "./Components/Activation/ActivationUserHistory";
import ActivationByAdminZeroPin from "./Components/Activation/ActivationByAdminZeroPin";
import ActivationHistoryZeroPin from "./Components/Activation/ActivationHistoryZeroPin";
import BinaryIncome from "./Components/Income Reports/BinaryIncome";
import RewardAchiever from "./Components/Income Reports/RewardAchiever";
import Withdrawal_Roi_Pending_List from "./Components/Withdrawal/Withdrawal_Roi_Pending_List";
import ActivationFund from "./Components/Add Fund/ActivationFund";
import AfundHistory from "./Components/Add Fund/AfundHistory";
import CTOIncome from "./Components/Income Reports/RoyaltyIncome";
import IncomeToFundConvert from "./Components/Add Fund/IncomeToFundConvert";
import UsertoUserTranssfer from "./Components/Add Fund/UsertoUserTranssfer";
import DownlineBusiness from "./Components/Team_Reports/DownlineBusiness";
import UsdtqrDetails from "./Components/Add Fund/UsdtqrDetails";
import PendingUsdtRequest from "./Components/Add Fund/PendingUsdtRequest";
import PaidUsdtRequest from "./Components/Add Fund/PaidUsdtRequest";
import FundReport from "./Components/Add Fund/FundReport";
import ActivationByAdmin_nonworking from "./Components/Activation/ActivationByAdmin_nonworking";
import ActivationUHistory_nonworking from "./Components/Activation/ActivationUHistory_nonworking";
import ActivationUserHistory_nonworking from "./Components/Activation/ActivationUserHistory_nonworking";
import DirectIncome_nonworking from "./Components/Income Reports/DirectIncome_nonworking";
import RoiIncome_nonworking from "./Components/Income Reports/RoiIncome_nonworking";
import LevelIncome_nonworking from "./Components/Income Reports/LevelIncome_nonworking";
import RoyaltyIncome from "./Components/Income Reports/RoyaltyIncome";
import RoyaltyIncome_nonworking from "./Components/Income Reports/RoyaltyIncome_nonworking";

function App() {
  // useEffect(() => {
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);

  //   document.addEventListener("keydown", (e) => {
  //     if (
  //       (e.ctrlKey &&
  //         (e.key === "I" ||
  //           e.key === "i" ||
  //           e.key === "u" ||
  //           e.key === "U" ||
  //           e.key === "J" ||
  //           e.key === "j" ||
  //           e.key === "C" ||
  //           e.key === "c")) ||
  //       e.key === "F12"
  //     ) {
  //       e.preventDefault();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route />
          <Route exact path="/" element={<Login />} />
          <Route exact path="/OPT_Confirm" element={<OPT_Confirm />} />
          <Route
            exact
            path="/Dashboard"
            element={<ProtectedRoute component={Dashboard} />}
          />
          <Route
            exact
            path="/Allmember"
            element={<ProtectedRoute component={All_member} />}
          />
          <Route
            exact
            path="/Dashboard_Message"
            element={<ProtectedRoute component={Message} />}
          />
          <Route
            exact
            path="/MessageHistory"
            element={<ProtectedRoute component={MessageHistory} />}
          />

          <Route
            exact
            path="/Member_Details"
            element={<ProtectedRoute component={Member_Details} />}
          />

          <Route
            exact
            path="/ActiveMember"
            element={<ProtectedRoute component={Active_Member} />}
          />

          <Route
            exact
            path="/upgradeMember"
            element={<ProtectedRoute component={Upgrade_MEMBER_LIST} />}
          />

          <Route
            exact
            path="/Activation"
            element={<ProtectedRoute component={ActivationByAdmin} />}
          />
          <Route
            exact
            path="/Non-working-Activation"
            element={
              <ProtectedRoute component={ActivationByAdmin_nonworking} />
            }
          />
          <Route
            exact
            path="/Upgrade"
            element={<ProtectedRoute component={UpgradeByAdmin} />}
          />

          <Route
            exact
            path="/upgradeid"
            element={<ProtectedRoute component={UpgradeID} />}
          />
          <Route
            exact
            path="/Non-Working-Activationhistory"
            element={
              <ProtectedRoute component={ActivationUHistory_nonworking} />
            }
          />
          <Route
            exact
            path="/Activationhistory"
            element={<ProtectedRoute component={ActivationUHistory} />}
          />
          <Route
            exact
            path="/ActivationUserHistory"
            element={<ProtectedRoute component={ActivationUserHistory} />}
          />
          <Route
            exact
            path="/NonWorkingActivationUserHistory"
            element={
              <ProtectedRoute component={ActivationUserHistory_nonworking} />
            }
          />
          <Route
            exact
            path="/ZeroPinActivation"
            element={<ProtectedRoute component={ActivationByAdminZeroPin} />}
          />

          <Route
            exact
            path="/ZeroPinActivationhistory"
            element={<ProtectedRoute component={ActivationHistoryZeroPin} />}
          />

          <Route
            exact
            path="/roirate"
            element={<ProtectedRoute component={RoiRate} />}
          />
          <Route
            exact
            path="/addpower"
            element={<ProtectedRoute component={AddPowerleg} />}
          />

          <Route
            exact
            path="/powerhistory"
            element={<ProtectedRoute component={PowerlegHis} />}
          />

          <Route
            exact
            path="/Withdrawal_History"
            element={<ProtectedRoute component={Withdrawal_Payment_Reports} />}
          />
          <Route
            exact
            path="/PaidClaimActvationHistory"
            element={<ProtectedRoute component={PaidClaimActvationHistory} />}
          />

          <Route
            exact
            path="/Pending_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Pending_List} />}
          />

          <Route
            exact
            path="/Pending_Roi_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Roi_Pending_List} />}
          />
          <Route
            exact
            path="/PendingClaimActvationHistory"
            element={
              <ProtectedRoute component={PendingClaimActvationHistory} />
            }
          />

          <Route
            exact
            path="/Buy"
            element={<ProtectedRoute component={Buy} />}
          />
          <Route
            exact
            path="/Sell"
            element={<ProtectedRoute component={Sell} />}
          />

          <Route
            exact
            path="/Edit_Details"
            element={<ProtectedRoute component={Edit_details} />}
          />
          <Route
            exact
            path="/HelpDesk"
            element={<ProtectedRoute component={HelpDesk} />}
          />
          <Route
            exact
            path="/ClosedHelpDesk"
            element={<ProtectedRoute component={ClosedHelpDesk} />}
          />
          <Route
            exact
            path="/Reply"
            element={<ProtectedRoute component={Reply} />}
          />
          <Route
            exact
            path="/News"
            element={<ProtectedRoute component={News} />}
          />
          <Route
            exact
            path="/PendingReward"
            element={<ProtectedRoute component={RequestToken} />}
          />
          <Route
            exact
            path="/PaidRewardHistory"
            element={<ProtectedRoute component={RequestTokenPaid} />}
          />
          <Route
            exact
            path="/RequestTokenUpdate"
            element={<ProtectedRoute component={RequestTokenUpdate} />}
          />
          <Route
            exact
            path="/Commission_Report"
            element={<ProtectedRoute component={Commission} />}
          />
          <Route
            exact
            path="/LoginHistory"
            element={<ProtectedRoute component={LoginHistory} />}
          />
          {/* <Route exact path="/ApprovedKyc" element={<ProtectedRoute component={ApprovedKyc}/>} />
        <Route exact path="/PendingKyc" element={<ProtectedRoute component={PendingKyc}/>} /> */}
          <Route
            exact
            path="/Manage_subadmin"
            element={<ProtectedRoute component={Manage_subadmin} />}
          />
          <Route
            exact
            path="/Subadmin_rights"
            element={<ProtectedRoute component={Subadmin_rights} />}
          />
          <Route
            exact
            path="/Edit_SubAdmin"
            element={<ProtectedRoute component={Edit_subAdmin} />}
          />
          <Route
            exact
            path="/Add_SubAdmin"
            element={<ProtectedRoute component={Add_subAdmin} />}
          />

          <Route
            exact
            path="/BinaryIncome"
            element={<ProtectedRoute component={BinaryIncome} />}
          />

          <Route
            exact
            path="/LevelIncome"
            element={<ProtectedRoute component={LevelIncome} />}
          />
          <Route
            exact
            path="/CTOIncome"
            element={<ProtectedRoute component={CTOIncome} />}
          />
          <Route
            exact
            path="/RoiIncome"
            element={<ProtectedRoute component={RoiIncome} />}
          />
          <Route
            exact
            path="/RewardAchiever"
            element={<ProtectedRoute component={RewardAchiever} />}
          />
          <Route
            exact
            path="/TeamReward_income"
            element={<ProtectedRoute component={TeamReward_income} />}
          />

          <Route
            exact
            path="/TeamRewardPaid"
            element={<ProtectedRoute component={TeamRewardPaid} />}
          />
          <Route
            exact
            path="/DirectIncome"
            element={<ProtectedRoute component={DirectIncome} />}
          />

          <Route
            exact
            path="/Total_incomeReport"
            element={<ProtectedRoute component={Total_incomeReport} />}
          />

          {/* <Route exact path="/Add_MarketCoin" element={<ProtectedRoute component={Add_MarketCoin}/>} /> 
        <Route exact path="/MarketCoinHistory" element={<ProtectedRoute component={MarketCoinHistory}/>} /> 
        <Route exact path="/Update_Coin_Details" element={<ProtectedRoute component={UpdateCoin}/>}/> */}
          <Route
            exact
            path="/My_Team"
            element={<ProtectedRoute component={My_Team} />}
          />
          <Route
            exact
            path="/DownlineBusiness"
            element={<ProtectedRoute component={DownlineBusiness} />}
          />
          <Route
            exact
            path="/myreferrals"
            element={<ProtectedRoute component={Direct_team} />}
          />
          <Route
            exact
            path="/Level_detail"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/DirectLegBusiness"
            element={<ProtectedRoute component={DirectLegBusiness} />}
          />

          <Route
            exact
            path="/levelDetails"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/Contact_Query"
            element={<ProtectedRoute component={Contact} />}
          />
          <Route
            exact
            path="/Add_HomePageCoin"
            element={<ProtectedRoute component={Add_HomePageCoin} />}
          />
          <Route
            exact
            path="/HomePageCoinDetails"
            element={<ProtectedRoute component={HomePageCoinDetails} />}
          />
          <Route
            exact
            path="/Update_HomePageCoin"
            element={<ProtectedRoute component={Update_HomePageCoin} />}
          />
          <Route
            exact
            path="/RequestTokenCancel"
            element={<ProtectedRoute component={RequestTokenCancel} />}
          />

          <Route
            exact
            path="/SubadminHistory"
            element={<ProtectedRoute component={SubadminHistory} />}
          />
          <Route
            exact
            path="/activationfund"
            element={<ProtectedRoute component={ActivationFund} />}
          />
          <Route
            exact
            path="/activationfundHis"
            element={<ProtectedRoute component={AfundHistory} />}
          />
          <Route
            exact
            path="/IncomeToFundConvert"
            element={<ProtectedRoute component={IncomeToFundConvert} />}
          />
          <Route
            exact
            path="/UsertoUserTranssfer"
            element={<ProtectedRoute component={UsertoUserTranssfer} />}
          />
          <Route
            exact
            path="/UsdtqrDetails"
            element={<ProtectedRoute component={UsdtqrDetails} />}
          />
          <Route
            exact
            path="/PendingUsdtRequest"
            element={<ProtectedRoute component={PendingUsdtRequest} />}
          />
          <Route
            exact
            path="/PaidUsdtRequest"
            element={<ProtectedRoute component={PaidUsdtRequest} />}
          />
          <Route
            exact
            path="/FundReport"
            element={<ProtectedRoute component={FundReport} />}
          />
          <Route
            exact
            path="/DirectIncome_nonworking"
            element={<ProtectedRoute component={DirectIncome_nonworking} />}
          />
          <Route
            exact
            path="/RoiIncome_nonworking"
            element={<ProtectedRoute component={RoiIncome_nonworking} />}
          />
          <Route
            exact
            path="/LevelIncome_nonworking"
            element={<ProtectedRoute component={LevelIncome_nonworking} />}
          />
          <Route
            exact
            path="/RoyaltyIncome"
            element={<ProtectedRoute component={RoyaltyIncome} />}
          />
          <Route
            exact
            path="/RoyaltyIncome_nonworking"
            element={<ProtectedRoute component={RoyaltyIncome_nonworking} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
